exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2J4J6Xae8J_H4A7cIVwtej {\n\n}\n", ""]);

// exports
exports.locals = {
	"reportsReport": "_2J4J6Xae8J_H4A7cIVwtej"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/pages/ReportsReport/ReportsReport.css
// module id = 9691
// module chunks = 23